import {MutationRegisterToVeriflyt} from "./graphql";
import {useMutation} from "react-apollo";
import {message} from "antd";
import {VeriflytTicketEditorApi} from "./veriflyt-ticket-editor";

export default function useRegisterPersonToVeriflyt(api: VeriflytTicketEditorApi){

    const [ mutate, { loading, error } ] = useMutation(MutationRegisterToVeriflyt, {
        variables: {
            personID: api.personID
        },
        onCompleted: () => {
            api.refetch();
        },
        onError: (err) => {
            console.error("Failed to register person to Veriflyt:", err);
            message.error("Failed to register person to Veriflyt. Check console for details.");
        },
        update: (cache, { data: { RegisterToVeriflyt } }) => {
            if (RegisterToVeriflyt) {
                cache.writeData({
                    id: 'Person:' + api.personID,
                    data: {
                        veriflytID: RegisterToVeriflyt.veriflytID,
                        _id: RegisterToVeriflyt._id
                    }
                });
            }
        }
    });

    function register(){
        return mutate();
    }

    return {
        register,
        loading,
        error
    }
}